'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExtraErrorData = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _getError = require('./getError');

var MAX_STRING_LEGNTH = 2000;
var KEYS_TO_OMIT = [
// added by IE
'number', 'description',

// added by safari
'line', 'column'];

var getExtraErrorData = exports.getExtraErrorData = function getExtraErrorData(action) {
  var error = (0, _getError.getError)(action);

  if (!error) return null;

  var keys = Object.keys(error).filter(function (key) {
    return !KEYS_TO_OMIT.includes(key);
  });

  if (!keys.length) return null;

  return keys.reduce(function (acc, key) {
    switch (_typeof(error[key])) {
      case 'boolean':
      case 'number':
        {
          acc[key] = error[key];
          break;
        }

      case 'string':
        {
          var suffix = error[key].length > MAX_STRING_LEGNTH ? '...' : '';
          acc[key] = '' + error[key].substr(0, MAX_STRING_LEGNTH) + suffix;
          break;
        }

      case 'function':
        {
          acc[key] = 'function() { /* Function removed */ }';
          break;
        }

      case 'object':
        {
          if (error[key] === null) {
            acc[key] = error[key];
          } else {
            acc[key] = '/* Object, Error, or Array removed */';
          }
          break;
        }

      default:
        break;
    }

    return acc;
  }, {});
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/action/operators/getExtraErrorData.js
// module id = 855
// module chunks = 2 3